import { render, staticRenderFns } from "./AddonAppWidget.vue?vue&type=template&id=70fbdc95&scoped=true"
import script from "./AddonAppWidget.vue?vue&type=script&lang=js"
export * from "./AddonAppWidget.vue?vue&type=script&lang=js"
import style0 from "./AddonAppWidget.vue?vue&type=style&index=0&id=70fbdc95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbdc95",
  null
  
)

export default component.exports